export const serverUrl = import.meta.env.VITE_APP_SERVER_API_URL
export const serverDirectUrl = import.meta.env.VITE_APP_SERVER_URL
export const latestExtensionVersion = import.meta.env.VITE_APP_EXTENSION_VERSION
const urlParams = new URLSearchParams(window.location.search)
export const currentUserVersion = urlParams.get('version') ?? ''
export const srcOrigin = urlParams.get('origin') ?? '*'
export const stripePricePlanIds = JSON.parse(import.meta.env.VITE_STRIPE_PRICE_PLAN_IDS)
export const LOG_API_URL = serverUrl + 'client-logs'
